module.exports = __webpack_public_path__ + "img/circle-table-10.846dc361.png";